import { render, staticRenderFns } from "./DashboardGrid.vue?vue&type=template&id=1dd8722f&scoped=true&"
import script from "./DashboardGrid.vue?vue&type=script&lang=js&"
export * from "./DashboardGrid.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGrid.vue?vue&type=style&index=0&id=1dd8722f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8722f",
  null
  
)

export default component.exports